export const PASSWORD_MIN_LENGTH = 8;
export enum AuthActionType {
  SIGN_UP = 'SIGN_UP',
  SIGN_IN = 'SIGN_IN',
}
